//Libs
import { Box } from "@material-ui/core";
import { Stores, StoresContext } from "Globals/Stores";
import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";

const StyledStatusBox = styled(Box)`
    padding: 5px 10px;
    span {
        color: white !important;
        font-size: 12px;
    }
`;
export interface IStatusBox {
    id: string;
}
export function StatusBox(props: IStatusBox) {
    const storesContext = useContext<Stores>(StoresContext);
    const [name, setName] = useState<string>("");
    const [colour, setColour] = useState<string>("");
    useEffect(() => {
        setColour(storesContext.Domain.ApplicantStatusStore.getApplicantStatusColor(props.id));
        setName(storesContext.Domain.ApplicantStatusStore.getApplicantStatusName(props.id));
    }, [props.id]);

    console.log("status name: " + name);

    return (
        <StyledStatusBox style={{ backgroundColor: colour }}>
            <span>{name}</span>
        </StyledStatusBox>
    );
}
